<div class="flex flex-column h-full w-full chat-root" style="position: relative;">


    <!-- ðŸ”¹ Container fixo para mensagens fixadas -->
    <div *ngIf="pinnedMessages.length > 0" class="pinned-messages-container">
        <swiper [slidesPerView]="'auto'" [spaceBetween]="10" class="mySwiperAlerts">
            <ng-template swiperSlide *ngFor="let alert of pinnedMessages">
                <div class="alert-card">
                    <div class="alert-icon-container">
                        <i class="bi bi-pin-angle alert-icon"></i>
                    </div>
                    <span class="alert-label">{{ alert.text }}</span>
                </div>
            </ng-template>
        </swiper>
    </div>

    <div class="chat-messages flex-1 overflow-y-auto p-3" #chatWindow [scrollTop]="chatWindow.scrollHeight">
        <!-- Skeleton Loader enquanto carrega -->
        <ng-container *ngIf="isLoadingMessages">
            <div *ngFor="let skel of [1,2,3,4]">
                <div class="flex align-items-start mb-4">
                    <p-skeleton shape="circle" width="38px" height="38px" class="mr-2"></p-skeleton>
                    <div style="width: 100%;">
                        <p-skeleton width="100%" height="70px" [style]="{'margin-bottom': '8px'}"></p-skeleton>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Threads: avatar sempre Ã  esquerda -->
        <div *ngFor="let thread of threads" class="ss-chat-thread mb-4 mt-4">
            <!-- Root -->
            <div [attr.id]="'msg-' + thread.root.id" class="ss-chat-message-row">
                <div class="flex align-items-start gap-2 w-full"
                    [ngClass]="thread.root.isOwnMessage ? 'justify-content-end' : 'justify-content-start'">

                    <ng-container *ngIf="!thread.root.isOwnMessage; else ownRoot">
                        <div class="ss-chat-avatar ">
                            <p-avatar [label]="getAvatarLabel(thread.root)" class="font-bold" size="normal" shape="circle"></p-avatar>
                        </div>

	                        <div class="w-full text-left">
	                            <div class="flex align-items-center gap-2 mb-1">
	                                <span
	                                    class="text-sm font-medium text-color-secondary white-space-nowrap overflow-hidden text-overflow-ellipsis">
	                                    {{ getDisplayName(thread.root) }}
	                                </span>
	                                <span *ngIf="thread.root?.is_admin" class="ss-verified-badge">
	                                    <i class="pi pi-check" pTooltip="Mensagem da loja" tooltipPosition="top"
	                                        tooltipEvent="focus" tabindex="0"></i>
	                                </span>
	                                <span class="text-xs text-color-secondary opacity-70 white-space-nowrap">
	                                    {{ thread.root.created_at | ssTimeago }}
	                                </span>
	                            </div>
                            <span class="inline-block text-left font-medium border-1 surface-border p-3 white-space-normal border-round text-xs"
                                [ngClass]="getBubbleClass(thread.root)" style="word-break: break-word; max-width: 80%;">
                                {{ thread.root.text }}
                            </span>

                            <div class="ss-chat-actions-row flex align-items-center justify-content-start mt-2">
                                <div>
                                    <a class="ss-g-link-responder cursor-pointer" *ngIf="isAdmin"
                                        (click)="onReplyMessage(thread.root)">
                                        responder
                                    </a>
                                    <a *ngIf="isAdmin" class="ss-g-link-remover cursor-pointer text-danger ml-3"
                                        (click)="onRemoveMessage(thread.root)">
                                        remover
                                    </a>
                                </div>
                            </div>
                        </div>
                    </ng-container>

	                    <ng-template #ownRoot>
	                        <div class="w-full" style="text-align: right;">
		                            <div class="flex align-items-center gap-2 mb-1" style="justify-content: flex-end;">
		                                <div class="ss-chat-avatar ">
		                                    <p-avatar [label]="getAvatarLabel(thread.root)" class="font-bold" size="normal" shape="circle"></p-avatar>
		                                </div>
		                                <span
		                                    class="text-sm font-medium text-color-secondary white-space-nowrap overflow-hidden text-overflow-ellipsis">
		                                    {{ getDisplayName(thread.root) }}
		                                </span>
                                        <span *ngIf="thread.root?.is_admin" class="ss-verified-badge">
                                            <i class="pi pi-check" pTooltip="Mensagem da loja" tooltipPosition="top"
                                                tooltipEvent="focus" tabindex="0"></i>
                                        </span>
                                        <span class="text-xs text-color-secondary opacity-70 white-space-nowrap">
                                            {{ thread.root.created_at | ssTimeago }}
                                        </span>
	                                </div>
                                    <span class="inline-block text-left font-medium border-1 surface-border p-3 white-space-normal border-round text-xs"
                                        [ngClass]="getBubbleClass(thread.root)" style="word-break: break-word; max-width: 80%;">
                                        {{ thread.root.text }}
                                    </span>

                            <div class="ss-chat-actions-row flex align-items-center justify-content-start mt-2"
                                style="justify-content: flex-end;" [ngClass]="{ 'ss-chat-actions-right': thread.root?.is_admin }">
                                <div>
                                    <a class="ss-g-link-responder cursor-pointer" *ngIf="isAdmin"
                                        (click)="onReplyMessage(thread.root)">
                                        responder
                                    </a>
                                    <a *ngIf="isAdmin" class="ss-g-link-remover cursor-pointer text-danger ml-3"
                                        (click)="onRemoveMessage(thread.root)">
                                        remover
                                    </a>
                                </div>
	                            </div>
	                        </div>
	                    </ng-template>

                </div>
            </div>

            <!-- Replies (indent) -->
            <div *ngFor="let message of thread.replies" [attr.id]="'msg-' + message.id"
                class="ss-chat-reply-row ml-4 mt-2">
                <div class="flex align-items-start gap-2 w-full"
                    [ngClass]="thread.root.isOwnMessage ? 'justify-content-end' : 'justify-content-start'">

                    <ng-container *ngIf="!thread.root.isOwnMessage; else ownReply">
                        <div class="ss-chat-avatar">
                            <p-avatar [label]="getAvatarLabel(message)" class="font-bold" size="normal" shape="circle"></p-avatar>
                        </div>
                        <div class="w-full text-left">
                            <div class="flex align-items-center gap-2 mb-1">
                                <span class="text-sm font-medium text-color-secondary white-space-nowrap overflow-hidden text-overflow-ellipsis">
                                    {{ getDisplayName(message) }}
                                </span>
                                <span *ngIf="message?.is_admin" class="ss-verified-badge">
                                    <i class="pi pi-check" pTooltip="Mensagem da loja" tooltipPosition="top"
                                        tooltipEvent="focus" tabindex="0"></i>
                                </span>
                                <span class="text-xs text-color-secondary opacity-70 white-space-nowrap">
                                    {{ message.created_at | ssTimeago }}
                                </span>
                            </div>
                            <span class="inline-block text-left font-medium border-1 surface-border p-2 white-space-normal border-round text-xs"
                                [ngClass]="getBubbleClass(message)" style="word-break: break-word; max-width: 80%;">
                                {{ message.text }}
                            </span>
                            <div class="ss-chat-actions-row flex align-items-center justify-content-start mt-2">
                                <div>
                                    <a class="ss-g-link-responder cursor-pointer" *ngIf="isAdmin"
                                        (click)="onReplyMessage(message)">
                                        responder
                                    </a>
                                    <a *ngIf="isAdmin" class="ss-g-link-remover cursor-pointer text-danger ml-3"
                                        (click)="onRemoveMessage(message)">
                                        remover
                                    </a>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #ownReply>
                        <div class="w-full" style="text-align: right;">
                            <div class="flex align-items-center gap-2 mb-1" style="justify-content: flex-end;">
                                <div class="ss-chat-avatar">
                                    <p-avatar [label]="getAvatarLabel(message)" class="font-bold" size="normal" shape="circle"></p-avatar>
                                </div>
                                <span class="text-sm font-medium text-color-secondary white-space-nowrap overflow-hidden text-overflow-ellipsis">
                                    {{ getDisplayName(message) }}
                                </span>
                                <span *ngIf="message?.is_admin" class="ss-verified-badge">
                                    <i class="pi pi-check" pTooltip="Mensagem da loja" tooltipPosition="top"
                                        tooltipEvent="focus" tabindex="0"></i>
                                </span>
                                <span class="text-xs text-color-secondary opacity-70 white-space-nowrap">
                                    {{ message.created_at | ssTimeago }}
                                </span>
                            </div>
                            <span class="inline-block text-left font-medium border-1 surface-border p-2 white-space-normal border-round text-xs"
                                [ngClass]="getBubbleClass(message)" style="word-break: break-word; max-width: 80%;">
                                {{ message.text }}
                            </span>
                            <div class="ss-chat-actions-row flex align-items-center mt-2" style="justify-content: flex-end;"
                                [ngClass]="{ 'ss-chat-actions-right': message?.is_admin }">
                                <div>
                                    <a class="ss-g-link-responder cursor-pointer" *ngIf="isAdmin"
                                        (click)="onReplyMessage(message)">
                                        responder
                                    </a>
                                    <a *ngIf="isAdmin" class="ss-g-link-remover cursor-pointer text-danger ml-3"
                                        (click)="onRemoveMessage(message)">
                                        remover
                                    </a>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                </div>
            </div>
        </div>

    </div>


    <div class="ss-g-input-group-chat p-3 flex flex-column align-items-center mt-auto surface-border gap-1"
        style="padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 1rem);">

        <!-- Banner de reply SEMPRE acima do input, FORA do input-group -->
        <div *ngIf="replyingToMessage"
            class="replying-to-banner surface-100 mb-2 flex align-items-center justify-content-between ss-g-input-group-chat p-0 md:p-0 lg:p-0 flex-column sm:flex-row align-items-center surface-border gap-1"
            style="border-radius: 8px; width: 100%; flex-wrap: wrap;">
            <div class="p-2" style="flex: 1 1 0; min-width: 0;">
                <span class="text-sm text-color-secondary"
                    style="word-break: break-all; overflow-wrap: break-word; min-width: 0; max-width: 100%; white-space: pre-wrap;">
                    {{ replyingToMessage.text || replyingToMessage.content }}
                </span>
            </div>
            <button pButton type="button" icon="pi pi-times" (click)="cancelReply()"
                class="p-button-text p-0 ml-2"></button>
        </div>


        <div class="ss-g-input-group-chat p-0 flex flex-column sm:flex-row align-items-center surface-border gap-1">
            <input id="message" type="text" pInputText placeholder="Digite uma mensagem..." [disabled]="disableSendInput"
                class="ss-g-input-text-chat font-italic mb-2" [(ngModel)]="textContent" (keydown.enter)="sendMessage()" />
	            <div class="ss-g-button-container-chat">
	                <div class="justify-content-center text-2xl ss-g-cursor-pointer p-2 ss-g-emojis"
	                    (click)="op.toggle($event)">😀</div>
	                <div class="justify-content-center text-2xl ss-g-cursor-pointer p-2 ss-g-sendMessage"
	                    (click)="sendMessage()"><i class="pi pi-send"></i></div>
	            </div>
        </div>
    </div>

</div>

<p-overlayPanel #op styleClass="w-full sm:w-30rem ss-g-custom-z-index-emojis">
    <ng-template pTemplate>
        <button *ngFor="let emoji of emojis;" pButton pRipple (click)="op.hide(); onEmojiSelect(emoji)" type="button"
            [label]="emoji" class="p-2 p-button-text text-2xl"></button>
    </ng-template>
</p-overlayPanel>
